import { Component, ChangeDetectionStrategy, ChangeDetectorRef, Input } from "@angular/core";
import { PeopleInfoTelephone } from "projects/sepidz-web-framework/src/lib/models/peopleInfo-telephone.model";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { TelephoneKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { Lookup, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { takeUntil } from "rxjs/operators";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";

@Component({
  selector: "ngx-telephone-form",
  templateUrl: "./telephone-form.component.html",
  styleUrls: ["./telephone-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TelephoneFormComponent extends BaseFormComponent<PeopleInfoTelephone> {
  erroremessage: string;
  @Input() Columns: form_control[];
  constructor(private lookupservice: LookupService, protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.noLoadData = true;
    super.ngOnInit();
    if (!this.apiName) this.apiName = "PeopleInfo";
    this.label = this.translate("ClientApp.GNR.PeopleInfo.Telephone.Telephone");
    this.setdefault();
  }
  async setColumns() {
    Object.assign(this.orignalColumns, this.Columns);
    this.orignalColumns.forEach((x) => {
      if (!x.tabOrder) x.tabOrder = x.order ?? 0;
    });
    this.columns = this.orignalColumns.filter(
      (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
    );
    this.columns = this.columns.sort((a, b) => a.order - b.order);
  }

  setdefault() {
    this.isNewRow = !this.currentrow;
    Object.assign(this.model, this.currentrow);
    if (this.model.IsDefault === undefined) this.model.IsDefault = false;
    this.setFormGroup(this.model);
    if (!this.model.PeopleInfoId) this.model.PeopleInfoId = 0;
    if (this.currentrow && this.currentrow.Id) this.id = !this.id ? this.currentrow.Id : this.id;
    if (!this.model.TelephoneKindId) {
      this.lookupservice
        .getLookupbyCode("GNR", "TelephoneKind", TelephoneKind.Mobile)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((stateKind) => {
          this.model.TelephoneKindId = stateKind.Id;
          this.model.TelephoneKindCode = stateKind.Code;
          this.model.TelephoneKindTitle = stateKind.Title;
          this.onChanged(stateKind);
        });
    }
    this.cd.markForCheck();
  }
  public async save() {
    this.result = this.getDataFromFormGroup();
    this.close();
  }
  onChanged($event) {
    if ($event && $event.SystemName) {
      this.model.TelephoneKindTitle = ($event as Lookup).Title;
      this.model.TelephoneKindCode = ($event as Lookup).Code;
      this.setValue("TelephoneKindTitle", this.model.TelephoneKindTitle);
      this.setValue("TelephoneKindCode", this.model.TelephoneKindCode);
    }
    this.columns.forEach((x) => {
      if (x.modelName === "Telephone" && this.model.TelephoneKindCode == TelephoneKind.Mobile) {
        x.patternKey = "^[0-0][9-9]\\d{9}";
        this.columns.find((t) => t.name === "IsDefault").disabled = false;
        this.setValue(x.name, this.formGroup?.get(x.name)?.value, x.required, x.patternKey);
      }
      if (x.modelName === "Telephone" && this.model.TelephoneKindCode !== TelephoneKind.Mobile) {
        x.patternKey = "^[1-9]\\d{3,7}";
        this.columns.find((t) => t.name === "IsDefault").disabled = true;
        this.setValue(x.name, this.formGroup?.get(x.name)?.value, x.required, x.patternKey);
      }
    });
  }
  isValid(): boolean {
    var flag: boolean = true;
    if (this.model.TelephoneKindCode == TelephoneKind.Mobile && (this.model.Telephone.length !== 11 || this.model.Telephone[0] !== "0")) {
      this.erroremessage = `${this.translate("ClientApp.GNR.PeopleInfo.Telephone.Format")} ${this.model.TelephoneKindTitle} ${this.translate(
        "ClientApp.GNR.PeopleInfo.Telephone.NotCorrect"
      )}`;
    }
    if (this.model.TelephoneKindCode !== TelephoneKind.Mobile && (this.model.Telephone.length < 4 || this.model.Telephone.length > 8)) {
      this.erroremessage = `${this.translate("ClientApp.GNR.PeopleInfo.Telephone.Format")} ${this.model.TelephoneKindTitle} ${this.translate(
        "ClientApp.GNR.PeopleInfo.Telephone.NotCorrect"
      )}`;
    }
    return flag;
  }
}
